import React from 'react';
import {Button, Stack, Typography} from "@mui/material";
import {Link as RouterLink} from 'react-router';

export const ReportNotFound = () => (
    <Stack alignItems="center" justifyContent="center" height="100%" spacing={2} p={4}>
        <Typography variant="h6">Report not found</Typography>
        <Button component={RouterLink} to="/products" variant="contained">Back to Products</Button>
    </Stack>
);

export const AccessError = () => (
    <Stack alignItems="center" justifyContent="center" height="100%" spacing={2} p={4}>
        <Typography variant="h6">Error checking access</Typography>
        <Button component={RouterLink} to="/products" variant="contained">See Products List</Button>
    </Stack>
);

export const AccessDenied = () => (
    <Stack alignItems="center" justifyContent="center" height="100%" spacing={2} p={4}>
        <Typography variant="h6">You do not have access to this Product</Typography>
        <Button component={RouterLink} to="/products" variant="contained">See Products List</Button>
    </Stack>
);
